import { validateEmail, validateName, validateContactNumber, validateSingleSelection } from '@om/validation';

import { setInsuranceTypeValid } from '../../../actions/allsureInsurance/insuranceType';

let prevValidationAction = null;
export const insuranceTypeValidations = (store, next, action) => {
    let flage = next(action);
    const { homeContent, homeOwners, motor } = store.getState().allsureInsurance.insuranceType.form;
    console.log(homeContent, homeOwners, motor);
    let storeData = [homeContent.value, homeOwners.value, motor.value]
    let storeCount = storeData.filter((f) => f === "primary").length
    console.log("storeData",storeData);
    console.log("storeCount",storeCount);
    const validateInsuranceType = (fieldType, value) => {
        if (storeCount === 0) {
            return "Please select the insurance to proceed"
        }
        return null;
        // if (value === 'primary') {
        //      console.log("if",homeContent, homeOwners, motor);
        //     // if (fieldType === 'motor') {
        //     //     return homeOwners.value === value || homeContent.value === value
        //     //         ? null
        //     //         : 'You’ll need to also select at least homeowners or home contents insurance.';
        //     // } else {
        //         return null;
        //     // }
        // } else {
        //     // if (fieldType === 'motor') {
        //     //     return homeContent.value === 'primary' || homeOwners.value === 'primary'
        //     //         ? null
        //     //         : 'Please select the insurance to proceed';
        //     // } else {
        //         // if (motor.value === 'primary') {
        //         //     if (fieldType === 'homeOwners'){
        //         //       return  homeContent.value === 'primary' ? null : 'You’ll need to also select at least homeowners or home contents insurance.';
        //         //     }
        //         //     if (fieldType === 'homeContent'){
        //         //        return homeOwners.value === 'primary' ? null : 'You’ll need to also select at least homeowners or home contents insurance.';
        //         //     }          
        //         // }
        //         console.log("else",homeContent, homeOwners, motor);
        //         if (fieldType === 'homeOwners') {
        //             return homeContent.value === 'primary' ? null : 'Please select 1 the insurance to proceed';
        //         }
        //         if (fieldType === 'homeContent') {
        //             return homeOwners.value === 'primary' ? null : 'Please select 2 the insurance to proceed';
        //         }
        //         if (fieldType === 'motor') {
        //             return motor.value === 'primary' ? null : 'Please select the 3 insurance to proceed';
        //         }
        //           console.log("SS",fieldType, value)
        //         return null;
        //     // }
        // }
    };
    const validationAction = (() => {
        const trimValue = (value) => (value ? value.trim() : value);
        const removeWhiteSpacesFromValue = (value) => (value ? value.replace(/ /g, '') : value);
        let error;
        switch (action.value.fieldType) {
            case 'privacyNotice':
                error = validateSingleSelection(action.value.value, 'Privacy notice');
                return setInsuranceTypeValid(error, action.value.fieldType);

            case 'motor':
                error = validateInsuranceType('motor', action.value.value);
                return setInsuranceTypeValid(error, action.value.fieldType);
            case 'homeOwners':
                error = validateInsuranceType('homeOwners', action.value.value);
                return setInsuranceTypeValid(error, 'motor');
            case 'homeContent':
                error = validateInsuranceType('homeContent', action.value.value);
                return setInsuranceTypeValid(error, 'motor');

            default:
                return null;
        }
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return flage;
};
